import styles from "./CartButton.module.css";
import cart from "../../../../assets/cart-icon.png";
import { useEffect, useState } from "react";

export default function CartButton({ count, onOpen }) {
  const [itemCount, setItemCount] = useState(0);

  useEffect(() => {
    if (itemCount !== count) {
      setTimeout(() => {
        setItemCount(count);
      }, [200]);
    }
  }, [count]);

  return (
    <div className={styles[`cart-button`]} onClick={onOpen}>
      <img src={cart} className={styles[`cart-icon`]} alt="Cart." />
      <div
        className={`${styles[`cart-counter`]} ${
          styles[itemCount !== count && `active`]
        }`}
      >
        {count > 99 ? "99+" : count}
      </div>
    </div>
  );
}
